module.exports = __webpack_public_path__ + "img/18.0e8253b4.png";